// extracted by mini-css-extract-plugin
export default {"wrap":"dG-z","subtitle":"eG-z","contentWrap":"fG-z","imgWrap":"gG-z","heading":"hG-z","copy":"iG-z"};